/* Página /buscar/: resultados vía Content API + catálogo de Productos */
(function () {
    const root = document.querySelector('[data-melo-site-search]');
    if (!root) {
        return;
    }

    const configuredSiteUrl = (root.dataset.siteUrl || '').replace(/\/+$/, '');
    const PROD_API_ORIGIN = 'https://meloagent.com';
    const apiKey = (root.dataset.apiKey || '').trim();
    const fallbackImage =
        root.dataset.fallbackImage || '/assets/images/solutions/default.svg';
    const queryEl =
        root.querySelector('[data-melo-search-query]') ||
        document.querySelector('[data-melo-search-query]');
    const loadingEl = root.querySelector('[data-melo-search-loading]');
    const emptyEl = root.querySelector('[data-melo-search-empty]');
    const listEl = root.querySelector('[data-melo-search-results]');
    const formEl = root.querySelector('[data-melo-search-form]');
    const formInput = formEl ? formEl.querySelector('input[name="q"]') : null;

    function readQuery() {
        return new URLSearchParams(window.location.search).get('q') || '';
    }

    function stripHtml(html) {
        const div = document.createElement('div');
        div.innerHTML = html || '';
        return (div.textContent || div.innerText || '').trim();
    }

    function normalizeText(str) {
        return String(str || '')
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-z0-9\s-]/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    }

    const STOP_WORDS = new Set([
        'de', 'del', 'la', 'las', 'el', 'los', 'en', 'por', 'para', 'con',
        'sin', 'un', 'una', 'unos', 'unas', 'y', 'o', 'a', 'al', 'como',
        'que', 'su', 'sus', 'tu', 'tus', 'mi', 'mis',
        'the', 'in', 'on', 'at', 'by', 'for', 'with', 'to', 'of', 'and', 'or', 'how'
    ]);

    function tokenizeQuery(query) {
        const normalized = normalizeText(query);
        if (!normalized) {
            return [];
        }
        const rawTokens = normalized.split(' ').filter(Boolean);
        const filtered = rawTokens.filter(function (token) {
            return token.length > 1 && !STOP_WORDS.has(token);
        });
        return filtered.length ? filtered : rawTokens;
    }

    function stemToken(token) {
        if (token.length > 4 && token.endsWith('es')) {
            return token.slice(0, -2);
        }
        if (token.length > 3 && token.endsWith('s')) {
            return token.slice(0, -1);
        }
        return token;
    }

    function scoreMatch(tokens, fullQueryNorm, titleText, bodyText) {
        const normTitle = normalizeText(titleText);
        const normBody = normalizeText(bodyText);
        const combined = normTitle + ' ' + normBody;

        if (!combined.trim()) {
            return 0;
        }

        let score = 0;
        if (fullQueryNorm && normTitle.includes(fullQueryNorm)) {
            score += 40;
        } else if (fullQueryNorm && combined.includes(fullQueryNorm)) {
            score += 20;
        }

        let matchedTokens = 0;
        tokens.forEach(function (token) {
            const stem = stemToken(token);
            const inTitle = normTitle.includes(token) || (stem.length >= 3 && normTitle.includes(stem));
            const inBody = normBody.includes(token) || (stem.length >= 3 && normBody.includes(stem));

            if (inTitle) {
                matchedTokens += 1;
                score += 12;
            } else if (inBody) {
                matchedTokens += 1;
                score += 5;
            }
        });

        if (matchedTokens === 0) {
            return 0;
        }

        if (tokens.length > 1 && matchedTokens === tokens.length) {
            score += 15;
        }

        return score;
    }

    const isEn = root.dataset.searchLocale === 'en';
    const copy = isEn
        ? {
            emptyPrompt: 'Type a search term to see results.',
            missingKey: 'Search is not configured. Add the Content API key in theme settings (melo_content_api_key).',
            noResults: function (term) {
                return 'No results for “' + term + '”. Try different words.';
            },
            failed: 'We could not load results. Check the Content API key or try again later.',
            article: 'Article',
            page: 'Page',
            product: 'Product',
            dateLocale: 'en-GB',
        }
        : {
            emptyPrompt: 'Escribe un término en el buscador para ver resultados.',
            missingKey: 'La búsqueda no está configurada. Añade la Content API key en Ajustes del tema (melo_content_api_key).',
            noResults: function (term) {
                return 'No encontramos resultados para «' + term + '». Prueba con otras palabras.';
            },
            failed: 'No pudimos cargar los resultados. Revisa la Content API key o inténtalo más tarde.',
            article: 'Artículo',
            page: 'Página',
            product: 'Producto',
            dateLocale: 'es-CL',
        };

    function formatDate(iso) {
        if (!iso) {
            return '';
        }
        try {
            return new Intl.DateTimeFormat(copy.dateLocale, {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
            }).format(new Date(iso));
        } catch (e) {
            return '';
        }
    }

    function excerptFromItem(item) {
        if (item.custom_excerpt) {
            return item.custom_excerpt;
        }
        if (item.excerpt) {
            return stripHtml(item.excerpt);
        }
        return '';
    }

    function normalizeResultUrl(rawUrl) {
        if (!rawUrl) {
            return '#';
        }
        try {
            const parsed = new URL(rawUrl, window.location.origin);
            if (
                parsed.origin === PROD_API_ORIGIN &&
                window.location.origin !== PROD_API_ORIGIN
            ) {
                return parsed.pathname + parsed.search + parsed.hash;
            }
            return parsed.href;
        } catch (e) {
            return rawUrl;
        }
    }

    function resolveAssetUrl(assetPath) {
        if (!assetPath) {
            return fallbackImage;
        }
        const cleaned = String(assetPath).trim();
        if (/^https?:\/\//i.test(cleaned) || cleaned.startsWith('/assets/')) {
            return cleaned;
        }
        return '/assets/' + cleaned.replace(/^\/+/, '');
    }

    function buildCard(item, typeLabel) {
        const li = document.createElement('li');
        li.className = 'melo-blog-index-item';

        const link = document.createElement('a');
        link.className = 'melo-blog-index-item-card';
        link.href = normalizeResultUrl(item.url);

        const media = document.createElement('figure');
        media.className = 'melo-blog-index-item-media';

        const img = document.createElement('img');
        img.className = 'melo-blog-index-item-img';
        img.src = item.feature_image || fallbackImage;
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.addEventListener('error', function onImgError() {
            img.removeEventListener('error', onImgError);
            if (img.src !== fallbackImage) {
                img.src = fallbackImage;
            }
        });
        media.appendChild(img);

        const content = document.createElement('div');
        content.className = 'melo-blog-index-item-content';

        const title = document.createElement('h3');
        title.className = 'melo-blog-index-item-title';
        title.textContent = item.title || '';

        const excerpt = document.createElement('p');
        excerpt.className = 'melo-blog-index-item-excerpt';
        excerpt.textContent = excerptFromItem(item);

        const meta = document.createElement('p');
        meta.className = 'melo-blog-index-item-meta';
        const parts = [];
        if (typeLabel) {
            parts.push(typeLabel);
        }
        const dateStr = formatDate(item.published_at);
        if (dateStr) {
            parts.push(dateStr);
        }
        meta.textContent = parts.join(' · ');

        content.appendChild(title);
        content.appendChild(excerpt);
        content.appendChild(meta);

        link.appendChild(media);
        link.appendChild(content);
        li.appendChild(link);

        return li;
    }

    function dedupeEntries(entries) {
        const seen = new Set();
        return entries.filter(function (entry) {
            const item = entry.item;
            const key = normalizeResultUrl(item.url) || item.slug;
            if (!key || seen.has(key)) {
                return false;
            }
            seen.add(key);
            return true;
        });
    }

    async function requestGhostApi(baseOrigin, endpoint, extraFilter) {
        const fields =
            'title,slug,url,custom_excerpt,excerpt,feature_image,published_at';
        const filterParam = extraFilter
            ? '&filter=' + encodeURIComponent(extraFilter.replace(/^\+/, ''))
            : '';
        const url =
            baseOrigin +
            '/ghost/api/content/' +
            endpoint +
            '/?key=' +
            encodeURIComponent(apiKey) +
            '&limit=100' +
            filterParam +
            '&fields=' +
            fields;

        return fetch(url);
    }

    async function fetchType(endpoint, query, extraFilter) {
        const primaryOrigin = configuredSiteUrl || window.location.origin;
        let response = await requestGhostApi(primaryOrigin, endpoint, extraFilter);

        if (!response.ok && primaryOrigin !== PROD_API_ORIGIN) {
            response = await requestGhostApi(PROD_API_ORIGIN, endpoint, extraFilter);
        }

        if (!response.ok) {
            throw new Error('search_failed');
        }

        const data = await response.json();
        const items = data.posts || data.pages || [];
        const tokens = tokenizeQuery(query);
        const fullQueryNorm = normalizeText(query);

        return items
            .map(function (item) {
                const body =
                    (item.custom_excerpt || '') +
                    ' ' +
                    stripHtml(item.excerpt || '') +
                    ' ' +
                    (item.slug || '');
                const score = scoreMatch(tokens, fullQueryNorm, item.title || '', body);
                return { item: item, score: score };
            })
            .filter(function (entry) {
                return entry.score > 0;
            })
            .sort(function (a, b) {
                return b.score - a.score;
            })
            .map(function (entry) {
                return entry.item;
            });
    }

    function searchCatalogProducts(query) {
        const catalogByLocale = window.MELO_APPS_CATALOG_BY_LOCALE;
        if (!catalogByLocale) {
            return [];
        }
        const localeKey = isEn ? 'en' : 'es';
        const localeCatalog = catalogByLocale[localeKey] || catalogByLocale.es;
        const apps = (localeCatalog && localeCatalog.apps) || [];
        const tokens = tokenizeQuery(query);
        const fullQueryNorm = normalizeText(query);
        const prefix = isEn ? '/en/apps/' : '/apps/';

        return apps
            .filter(function (app) {
                return app.showInSearch !== false;
            })
            .map(function (app) {
                const body =
                    (app.subtitle || '') +
                    ' ' +
                    (app.description || '') +
                    ' ' +
                    (app.searchKeywords || '') +
                    ' ' +
                    (app.slug || '');
                const score = scoreMatch(tokens, fullQueryNorm, app.title || '', body);
                return {
                    score: score,
                    item: {
                        title: app.title,
                        slug: app.slug,
                        url: prefix + app.slug + '/',
                        custom_excerpt: app.shortDescription || app.subtitle || '',
                        feature_image: resolveAssetUrl(app.searchImage || app.iconImage),
                        published_at: null,
                    },
                };
            })
            .filter(function (entry) {
                return entry.score > 0;
            })
            .sort(function (a, b) {
                return b.score - a.score;
            })
            .map(function (entry) {
                return entry.item;
            });
    }

    async function runSearch(query) {
        const trimmed = query.trim();
        if (queryEl) {
            queryEl.textContent = trimmed;
        }
        if (formInput) {
            formInput.value = trimmed;
        }

        if (!trimmed) {
            if (loadingEl) {
                loadingEl.hidden = true;
            }
            if (emptyEl) {
                emptyEl.hidden = false;
                emptyEl.textContent = copy.emptyPrompt;
            }
            if (listEl) {
                listEl.innerHTML = '';
            }
            return;
        }

        if (!apiKey) {
            if (loadingEl) {
                loadingEl.hidden = true;
            }
            if (emptyEl) {
                emptyEl.hidden = false;
                emptyEl.textContent = copy.missingKey;
            }
            return;
        }

        if (loadingEl) {
            loadingEl.hidden = false;
        }
        if (emptyEl) {
            emptyEl.hidden = true;
        }
        if (listEl) {
            listEl.innerHTML = '';
        }

        try {
            const catalogMatches = searchCatalogProducts(trimmed).map(function (item) {
                return { item: item, label: copy.product };
            });

            const [posts, pages] = await Promise.all([
                fetchType('posts', trimmed, isEn ? 'tag:hash-en' : 'tag:-hash-en'),
                fetchType('pages', trimmed, ''),
            ]);

            const combined = dedupeEntries(
                catalogMatches
                    .concat(
                        posts.map(function (item) {
                            return { item: item, label: copy.article };
                        })
                    )
                    .concat(
                        pages.map(function (item) {
                            return { item: item, label: copy.page };
                        })
                    )
            );

            if (loadingEl) {
                loadingEl.hidden = true;
            }

            if (!combined.length) {
                if (emptyEl) {
                    emptyEl.hidden = false;
                    emptyEl.textContent = copy.noResults(trimmed);
                }
                return;
            }

            combined.forEach(function (entry) {
                if (listEl) {
                    listEl.appendChild(buildCard(entry.item, entry.label));
                }
            });
        } catch (err) {
            if (loadingEl) {
                loadingEl.hidden = true;
            }
            if (emptyEl) {
                emptyEl.hidden = false;
                emptyEl.textContent = copy.failed;
            }
        }
    }

    runSearch(readQuery());
})();
